import React, {useEffect} from "react";
import "./App.css";
import Login from "./Login";
// ❌ old implicit flow import – you don't need this anymore
// import { getTokenFromUrl } from "./spotify";

import {handleSpotifyRedirect} from "./spotify"; // ⬅️ PKCE helper
import SpotifyWebApi from "spotify-web-api-js";
import Player from "./Player";
import {useDataLayerValue} from "./DataLayer";

const spotifyApi = new SpotifyWebApi();
const API_BASE = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://api.aspiewonder.com";

function App() {
  const [{token}, dispatch] = useDataLayerValue();

  useEffect(() => {
    const initAuth = async () => {
      // 1️⃣ Check for existing token in localStorage (same as before)
      const savedToken = localStorage.getItem("spotify_token");

      if (savedToken) {
        spotifyApi.setAccessToken(savedToken);
        dispatch({
          type: "SET_TOKEN",
          payload: savedToken,
        });
        return;
      }

      // 2️⃣ No saved token → check if this is a redirect from Spotify (?code=...)
      const accessToken = await handleSpotifyRedirect(); // ⬅️ PKCE exchange

      if (accessToken) {
        // store + configure API + update context
        localStorage.setItem("spotify_token", accessToken);
        spotifyApi.setAccessToken(accessToken);
        dispatch({
          type: "SET_TOKEN",
          payload: accessToken,
        });
      }
      // 3️⃣ If no code & no token → user stays logged out, sees <Login />
    };

    initAuth();
  }, [dispatch]);

  // Handle token expiration (unchanged)
  useEffect(() => {
    if (token) {
      spotifyApi.getMe().then(async () => {
        await fetch(`${API_BASE}/login`, {
          // const res = await fetch(`${path}`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "token": token },
        })
      }).catch((error) => {
        console.error("Token expired or invalid:", error);
        localStorage.removeItem("spotify_token");
        dispatch({
          type: "LOGOUT",
        });
      });
    }
  }, [token, dispatch]);

  return (
    <div className="App">
      {token ? <Player spotifyApi={spotifyApi}/> : <Login/>}
    </div>
  );
}

export default App;
